const getAllProductsPathsQuery = /* GraphQL */ `
  query getAllProductsPaths($first: Int = 250) {
    products(first: $first) {
      edges {
        node {
          handle
          updatedAt
        }
      }
    }
  }
`

export default getAllProductsPathsQuery
